export default "__VITE_ASSET__ux2xZRrw__"